/*import { createStore, combineReducers } from "redux";
import counterReducer from "./counterSlice";

const rootReducer = combineReducers({
  counter: counterReducer,
});

export const store = createStore(rootReducer);
*/

// ----------------------------------------------------

// import { AppState as FlexAppState } from "@twilio/flex-ui";
import {
  combineReducers,
  createStore,
  Action as ReduxAction,
} from "@reduxjs/toolkit";
//import { CustomTaskListState, reduce as CustomTaskListReducer } from './CustomTaskListState';
import { TabsState, reduce as TabsStateReducer } from "./TabsState/TabsState";
// import {
//   TasksState,
//   reduce as TasksStateReducer,
// } from "./TasksState/TasksState";
import {
  CustomersState,
  reduce as CustomersStateReducer,
} from "./CustomersState/CustomerState";
import { CrmState, reduce as CrmStateReducer } from "./Crm/CrmState";
import {
  WorkersState,
  reduce as WorkersStateReducer,
} from "./WorkersState/WorkersState";
import {
  ITechnicianContactsState,
  reduce as TechnicianContactsStateReducer,
} from "../communications/states/Contacts/TechnicianContactsState";
import {
  ICustomerContactsState,
  reduce as CustomerContactsStateReducer,
} from "../communications/states/Contacts/CustomerContactsState";
// import { TechnicianContactsState } from '../communications/states/Contacts/TechnicianContactsState';

import {
  MessagesState,
  reduce as MessagesStateReducer,
} from "../communications/states/Messages/MessagesState";
import {
  WorkspacesState,
  reduce as WorkspacesStateReducer,
} from "../communications/states/WorkspacesState";
import { CounterState, reduce as CounterStateReducer } from "./counterSlice";
import { AuthState, reduce as AuthStateReducer } from "./AuthState";
// WorkspacesStateReducer

// Register your redux store under a unique namespace
export const namespace = "call-center";

// Extend this payload to be of type that your ReduxAction is
export interface Action extends ReduxAction {
  payload?: any;
}

// Register all component states under the namespace
export interface AppState {
  // flex: FlexAppState;
  auth: AuthState;
  "call-center": {
    // --- Callcenter UI states
    //customTaskList: CustomTaskListState
    // tasks: TasksState;
    customers: CustomersState;
    tabs: TabsState;
    crm: CrmState;
    workers: WorkersState;

    // --- Communication UI states
    // communication: ITechnicianContactsState
    cmnc_tech_contacts: ITechnicianContactsState;
    cmnc_cust_contacts: ICustomerContactsState;
    // cmnc_common
    messages: MessagesState;
    // Other states
    cmnc_users: WorkspacesState;
    counter: CounterState;
  };
}

// Combine the reducers
export const reducers = combineReducers({
  auth: AuthStateReducer,
  "call-center": combineReducers({
    //customTaskList: CustomTaskListReducer,
    // tasks: TasksStateReducer,
    tabs: TabsStateReducer,
    customers: CustomersStateReducer,
    crm: CrmStateReducer,
    workers: WorkersStateReducer,
    // communication: ContactsStateReducer,
    cmnc_tech_contacts: TechnicianContactsStateReducer,
    cmnc_cust_contacts: CustomerContactsStateReducer,
    // cmnc_common
    messages: MessagesStateReducer,
    cmnc_users: WorkspacesStateReducer,
  }),
  counter: CounterStateReducer,
});

export const store = createStore(reducers);
